module.exports = __webpack_public_path__ + "media/images/btn_save_add_cover-7e1bfec49a9c610bcf0e1884b79bd329.gif";